(function () {
  'use strict';

  if (window.mbAtcStateInitialized) return;
  window.mbAtcStateInitialized = true;

  const selector = '[data-mb-atc]';

  function syncButton(button) {
    const unavailable = button.classList.contains('is-disabled');
    const loading = button.getAttribute('aria-busy') === 'true';
    const disabled = unavailable || loading;

    if (button.disabled !== disabled) {
      button.disabled = disabled;
    }
  }

  function syncWithin(root) {
    if (!(root instanceof Element)) return;

    if (root.matches(selector)) {
      syncButton(root);
    }

    root.querySelectorAll(selector).forEach(syncButton);
  }

  function init() {
    syncWithin(document.documentElement);

    const observer = new MutationObserver((mutations) => {
      const buttons = new Set();

      for (const mutation of mutations) {
        if (mutation.type === 'attributes') {
          if (mutation.target.matches(selector)) {
            buttons.add(mutation.target);
          }

          continue;
        }

        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;

          if (node.matches(selector)) {
            buttons.add(node);
          }

          node.querySelectorAll(selector).forEach((button) => {
            buttons.add(button);
          });
        }
      }

      buttons.forEach(syncButton);
    });

    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'aria-busy']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();